import Vue from 'Vue'
import App from './app.vue'
import 'normalize.css'

/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/pages/index/index.js